/* 서버에 요청을 보내기 전, 프론트에서 먼저 "완전히 동일한 수업"인지 판정한다.
"완전 동일"의 기준: 학년도·과정·학년·반·학기·수업명·교사 구성이 모두 같아야 한다.
교사는 인원 수까지 정확히 같아야 한다 (교사 1명인 수업과 2명인 수업은 다른 수업으로 본다).
subject_name이 없거나 teachers가 비어있는 상태는 다른 필수값 검증에서 걸러지므로 여기서는 통과시킨다
(빈 값끼리 우연히 일치해서 정상적인 저장까지 막는 것을 방지). */

function normalizeTeacherKey(teachers) {
  if (!Array.isArray(teachers)) return "";
  return teachers
    .map((teacher) => teacher?.username || "")
    .filter(Boolean)
    .sort()
    .join(",");
}

/**
 * @param {object} candidate 저장하려는 수업 (creUpdateLesson)
 * @param {Array} existingLessons 학교 전체 수업 목록
 * @param {number|string|null} [excludeId] 비교에서 제외할 자기 자신의 id (수정 시 사용)
 * @returns {boolean} 완전히 동일한 조건의 수업이 이미 존재하면 true
 */
export function isDuplicateLesson(
  candidate,
  existingLessons,
  excludeId = null,
) {
  if (!Array.isArray(existingLessons) || existingLessons.length === 0)
    return false;
  if (!candidate) return false;

  const name = (candidate.subject_name || "").trim();
  if (!name) return false;

  const candidateTeacherKey = normalizeTeacherKey(candidate.teachers);
  if (!candidateTeacherKey) return false;

  return existingLessons.some((row) => {
    if (excludeId !== null && String(row.id) === String(excludeId))
      return false;

    if (String(row.school_year_id) !== String(candidate.school_year_id))
      return false;
    if (String(row.hierarchy_one) !== String(candidate.hierarchy_one))
      return false;
    if (String(row.hierarchy_two) !== String(candidate.hierarchy_two))
      return false;
    if (String(row.hierarchy_three) !== String(candidate.hierarchy_three))
      return false;
    if (String(row.term_id) !== String(candidate.term_id)) return false;
    if ((row.subject_name || "").trim() !== name) return false;

    return normalizeTeacherKey(row.teachers) === candidateTeacherKey;
  });
}
